// import moment from 'moment'
export default [
    {
        text: 'Código',
        sortable: false,
        value: 'code',
    },
    {
        text: 'Mes',
        sortable: false,
        value: 'month_str',
    },
    {
        text: 'Año',
        sortable: false,
        value: 'year',
    },
    {
        text: 'Revisado',
        value: 'isReviewed',
        format: 'boolean',
        sortable: false,
    },
]
